import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { withRouter } from 'react-router';
import * as routes from '../constants/routes';
import { Link,Redirect } from 'react-router-dom';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import axios from 'axios';
import * as db from '../db/db';
import moment from 'moment'
import * as statuses from '../constants/requestStatus';
import { AppContext } from "../context/applicationContext";
import ExitToApp from '@material-ui/icons/ExitToApp';
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import ViewListRoundedIcon from '@material-ui/icons/ViewListRounded';
import Logo from '../assets/LIREX-logo.png';
import Spinner from '../shared/spinner';
import SmallSpinner from '../shared/small-spinner';
import QueueRoundedIcon from '@material-ui/icons/QueueRounded';
import HolidaysTable from '../features/holidaysTable';
import * as clients from '../clients';
import { withSnackbar } from 'notistack';

const baseUrl = (process.env.PUBLIC_URL==='/'?'': process.env.PUBLIC_URL) ||'';

const testWithBuild = 'http://localhost:8080';

const env = process.env.NODE_ENV;

const styles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing(2.5),
    },
    paper: {
        marginTop: theme.spacing(3),
        marginBottom: 24,
        padding: 5,
        [theme.breakpoints.up(800 + theme.spacing(3 * 2))]: {
            marginTop: theme.spacing(6),
            marginBottom: theme.spacing(6),
            padding: theme.spacing(3),
        },
        background: 'rgb(255 255 255 / 96%)',
    },
    layout: {
        width: 'auto',
        marginLeft: 5,
        marginRight: 5,
        [theme.breakpoints.up(800 + theme.spacing(2 * 2))]: {
            width: 800,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    progress: {
        margin: theme.spacing(2),
        top: '50%!important',
        position: 'absolute'
    },
    buttons: {
        justifyContent: 'flex-end'
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(0),
        width: '100%',
        color: 'white',
        backgroundColor: '#3a3f4b!important',
        justifyContent: 'center'
    },
    buttonForApproved: {
        marginTop: '7px!important',
        marginLeft: theme.spacing(0),
        width: '100%',
        color: 'white',
        backgroundColor: '#3a3f4b!important',
        justifyContent: 'center'
    }

});

let counter = 0;
function createData(id, title, status, employee, dateFrom, dateTo) {
    counter += 1;
    return { 'id': id, 'title': title, 'status': status, 'employee': employee, 'dateFrom': dateFrom, 'dateTo': dateTo};
}
class MyHolidays extends React.Component {
    static contextType = AppContext;
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            rows: [],
            page: 0,
            rowsPerPage: 10,
            userSite: null,
            userId: null,
            redirectToEdit: false,
            holidayId: null,
            siteUrl: null,
            progress: true,
            viewRequest: true,
            redirectToAddNew: false,
            redirectToHolidaysList: false,
            approveListDisabled: false,
            syncProgress: true,
        };
    }

    componentDidMount() {
        // if (localStorage.getItem('Unauthorized') === null) {
       
        this.context.setStateCustom('redirectFrom', 'myHolidays');
        if (this.context.userId !== null && this.context.userId !== undefined) {
            var ua = window.navigator.userAgent;
            var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
            var webkit = !!ua.match(/WebKit/i);
            var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
            if (!iOSSafari) {
                this.askForNotificationPermission();
            }
            this.setState({ userId: this.context.userId });
            db.idbMethods.get(this.context.userId, db.userInfo).then((userInfo) => {
                if (userInfo != undefined && userInfo.userPrimaryCompany != null) {
                    this.setState({ userSite: userInfo.userPrimaryCompany.companyURL });
                    this.setState({ progress: true });
                    this.setState({ syncProgress: true });
                    // console.log('before request',new Date());
                    // setTimeout(() => {
                    //     console.log('after timer request',new Date());
                        this.getHolidaysList(this.context.userId, userInfo.userPrimaryCompany.companyURL);
                     // }, 5000);
                  
                    if (userInfo.FullName === undefined) {
                        this.getUserData(this.context.userId, userInfo.userPrimaryCompany.companyURL);
                    }
                   
                    //Взимане на данните за моите отпуски от базата и зареждане на списъка
                    var rows = [];
                    db.idbMethods.getAll(db.myHolidays).then((myHolidays) => {

                        if (myHolidays[0] !== undefined) {
                            myHolidays[0].forEach((element, i) => {
                                const index = element.Title.indexOf(' №') + 2;
                                const row = createData(element.Id, element.Title.substr(index), element.Status, element.employeeName, this.formatTime(element.DateFrom), this.formatTime(element.DateTo));
                                rows.push(row);
                                if (i === myHolidays[0].length - 1) {
                                    this.setState({ rows: rows });
                                    this.setState({ progress: false });
                                   // this.setState({ syncProgress: false });
                                }
                            });
                        } else {
                            this.setState({ progress: true });
                        }
                    });
                    db.idbMethods.getAll(db.holidaysForApprove).then((holidays) => {
                        if (holidays[0] !== undefined) {
                            if (holidays[0].length !== 0) {
                                this.setState({ approveListDisabled: true });
                            }
                        }
                    });

                    var userSites = '';
                    userSites = userInfo.userPrimaryCompany.companyURL + '*';
                    if (userInfo.userSecondaryCompanys) {
                        userInfo.userSecondaryCompanys.forEach((company, i) => {
                            userSites = userSites + company.companyURL + '*';
                        });

                    }
                    this.disableButton(this.context.userId, userSites);

                } else {
                    this.setState({ rows: [] });
                    this.setState({ progress: false });
                }
            });
            // }
        } else {
            this.logOut();
        }
    }

    askForNotificationPermission = () => {
        if (Notification !== undefined) {
            Notification.requestPermission((result) => {
                if (result !== 'granted') {
                    console.log('No notification permission granted!');
                } else {
                    const isMobile = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
                    db.idbMethods.getAll(db.subscription).then((sub) => {
                        if (sub === undefined || sub === null || sub.length === 0) {
                            if ("serviceWorker" in navigator) {
                                clients.methods.send('employee').then(() => {
                                    db.idbMethods.set(isMobile, db.subscription);
                                }).catch(err => console.log(err));
                            }
                        }else {
                            this.checkForSubsciptions();
                        }
                    }).catch(err => {
                        console.error(err)
                        if ("serviceWorker" in navigator) {
                            clients.methods.send('employee').then(() => {
                                db.idbMethods.set(isMobile, db.subscription);
                            }).catch(err => console.log(err));
                        }
                    });
                }
                // this.displayConfirmNotification();
            });
        }
    }

    checkForSubsciptions = () => {
        const link = 'api/checkUserSub';
        axios.post(link, { user :{
            "UserCompanys": this.context.userSite,
            "UserId": this.context.userId,
            "RowLimit": 30
        },"type":"user"
        }, { headers: { 'Authorization': 'Bearer ' + this.context.token } })
            .then(res => {
                console.log('check for Subsscribtion',res);
                if (res.status === 200) {
                    if (res.data !== undefined && res.data.validSub === false) {
                        db.idbMethods.clear(db.subscription).then(() => {
                        const isMobile = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
                        if ("serviceWorker" in navigator) {
                            clients.methods.send('employee').then(() => {
                                db.idbMethods.set(isMobile, db.subscription);
                            }).catch(err => console.log(err));
                        }
                    });
                    }
                }
            }).catch(error => {
                console.log(error);
            })
    }

    getHolidaysList = (id, userSite) => {
        // const link = env === 'development' ? 'http://sf-spsdev07:42325/api/Holidays/GetAllMyHolidays?l=1026' : `/api/GetAllMyHolidays`;
        this.setState({ syncProgress: true });
        const link = baseUrl + `/api/GetAllMyHolidays`;
        axios.post(link, {
            "SiteUrl": userSite,
            "UserId": id,
            "RowLimit": 30
            //}, { headers: { 'Authorization': 'Bearer ' + this.context.token } })
        })
            .then(res => {
                console.log('after response of  request getAllMyHolidays',new Date(),res.data, res.data.holidays);
                if (res.status === 200) {
                    const rows = [];
                    if (res.data !== "") {
                        var myHolidays = res.data.holidays;
                        myHolidays.forEach((element, i) => {
                            const index = element.Title.indexOf(' №') + 2;
                            const row = createData(element.Id, element.Title.substr(index), element.Status, element.employeeName, this.formatTime(element.DateFrom), this.formatTime(element.DateTo));
                            rows.push(row);
                            if (i === myHolidays.length - 1) {
                                console.log('last holiday',rows);
                                db.idbMethods.clear(db.myHolidays);
                                db.idbMethods.set(myHolidays, db.myHolidays);
                                this.setState({ rows: rows });
                                this.setState({ progress: false });
                                this.setState({ syncProgress: false });
                            }
                        });

                    }
                }
            }).catch(error => {
                this.setState({ approveListDisabled: false });
                this.setState({ progress: false });
                this.setState({ syncProgress: false });
                //  this.setState({ redirect: true });
                var errorObj = JSON.parse(JSON.stringify(error));
                console.log(errorObj);
                if (errorObj.response && errorObj.response.status === 401) {
                    this.logOut();
                }
            })
    }

    disableButton = (id, userSite) => {
        this.setState({ progress: true });
        const link = baseUrl + `/api/allHolidays`;
        axios.post(link, {
            "UserCompanys": userSite,
            "UserId": id,
            "RowLimit": 30
        }, { headers: { 'Authorization': 'Bearer ' + this.context.token } })
            .then(res => {
                if (res.status === 200) {
                    let ids = [];
                    if (res.data !== "") {
                        res.data.forEach((element, i) => {
                            ids.push(element.Id);
                            if (i === res.data.length - 1) {
                                db.idbMethods.clear(db.holidaysForApprove);
                                db.idbMethods.set(ids, db.holidaysForApprove);
                            }

                        });
                        this.setState({ approveListDisabled: true });
                    } else {
                        this.setState({ approveListDisabled: false });
                    }

                }
            }).catch(error => {
                console.log(error);
                this.setState({ progress: false });
                var errorObj = error;
                console.log(errorObj);
                if (errorObj.response === undefined || errorObj.response.status === 401) {
                    // this.logOut();
                }

            })
    }

    logOut = () => {
        this.context.setStateCustom('userId', null);
        db.idbMethods.clear(db.userInfo);
        db.idbMethods.clear(db.holidaysForApprove);
        db.idbMethods.clear(db.holidaysForApproveList);
        db.idbMethods.clear(db.myHolidays);
        this.setState({ redirect: true });
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleUserData = (e) => {
        this.setState({ userData: e });
        this.props.callbackData({ userData: e });   
    }

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    redirectToHolidaysList = () => {
        this.setState({ redirectToHolidaysList: true });
    }

    openHolidayForEdit = (id) => {
        this.setState({ redirectToEdit: true });
        this.setState({ holidayId: id });
        //this.setState({ siteUrl: siteUrl });
    }

    formatTime = (time) => {
        return moment(time).format('DD.MM.YYYY');;
    }

    addNewrequest = () => {
        this.setState({ redirectToAddNew: true });
    }

    setRowStyle = (requestType) => {
        switch (requestType) {
            case statuses.REJECTED:
                return 'reject-request';
            case statuses.APPROVE:
                return 'approve-request';
            case statuses.CANCELED:
                return 'canceled-request';
            case statuses.FOR_CONFIRM:
                return 'confirm-first-level';
            case statuses.FOR_CONFIRM_REJECT:
                return 'confirm-reject-first-level';
            default:
                return 'confirm-first-level';
        }
        

    }

    getUserData(id, siteUrl) {
        const link = baseUrl + '/api/getUserData';
  
        axios.post(link, {
            "SiteUrl": siteUrl,
            "UserId": id
        }, { headers: { 'Authorization': 'Bearer ' + this.context.token } })
            .then(res => {
                if (res.status === 200) {
                    this.props.enqueueSnackbar('Успешен вход!', { variant: "success" });
                    let replacmentsArr = [];
                    res.data.Replacements.forEach(rep => {
                        replacmentsArr.push({ id: rep.UserID, label: rep.FullName });
                    });
                    this.setState({ fullName: res.data.FullName, employe: res.data, replacementUsers: replacmentsArr, progress: false });

                    db.idbMethods.getAll(db.userInfo).then((userInfo) => {
                        if (userInfo !== undefined || userInfo !== null || userInfo.length !== 0) {
                            var user = userInfo[0];
                            user.Days = res.data.Days;
                            user.Department = res.data.Department;
                            user.UserPosition = res.data.UserPosition;
                            user.FullName = res.data.FullName;
                            this.handleUserData(user);
                            db.idbMethods.set(user, db.userInfo);
                        }
                    })
                }
            }).catch(error => {
                console.log(error);
                var errorObj = JSON.parse(JSON.stringify(error));
               // this.props.enqueueSnackbar(errorObj.response.data.errorMsg, { variant: "error" });
                this.setState({ redirect: true });
                this.logOut();
            })
    }  

    tableLabel = (from, to, count) => {
        return `${from}-${to} от ${count}`;
    }

    render() {
        //const { classes, count, page, rowsPerPage, theme } = this.props;
        const { classes } = this.props;
        const { rows, rowsPerPage, page } = this.state;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
        const appClass = `${classes.appBar} ${this.state.progress ? 'pointer-none' : ''}`;
        const mainClass = `${classes.layout} ${this.state.progress ? 'pointer-none' : ''}`;

        if (this.state.redirect) {
            return <Redirect to={routes.HOME_LOGIN} />
        }
        if (this.state.redirectToHolidaysList) {
            return <Redirect to={routes.HOLIDAYS} />
        }
        if (this.state.redirectToAddNew) {
            return <Redirect to={routes.HOLIDAYS_FORM} />
        }
        if (this.state.redirectToEdit) {
            return <Redirect to={baseUrl +'/holidayView/' + this.state.holidayId} />
        }
        return (
            <React.Fragment>
            {/* {this.state.progress ? <div className='align-center spiner-pos'><CircularProgress className={classes.progress} /></div> : null} */}
            {this.state.progress ? <Spinner></Spinner> : null}
            <CssBaseline />
            <main className={mainClass + ' header-mrg'}>
                <Paper className={classes.paper}>
                    <h4 className='title-custom'>
                        Моите отпуски
                    </h4>
                    <Typography component="h6" variant="h6" align="center" className="pos-relative">
                        {this.state.syncProgress ? <SmallSpinner></SmallSpinner> : null}
                    </Typography>
                    <Grid item xs={12} sm={12}>
                        <div className={classes.buttons}>
                            <Button
                                size="small"
                                variant="contained"
                                component={Link} to={baseUrl +"/holidays"}
                                color="primary"
                                className={classes.button}>
                                <QueueRoundedIcon className='white-back-button'></QueueRoundedIcon> Добави
                               </Button>

                            {this.state.approveListDisabled ?

                                <Button
                                    size="small"
                                    variant="contained"
                                    component={Link} to={baseUrl +"/allHolidays"}
                                    onClick={this.redirectToHolidaysList}
                                    className={classes.buttonForApproved + ' add-holiday'}>
                                    <ViewListRoundedIcon className='white-back-button'></ViewListRoundedIcon>за одобрение
                                    </Button>
                                : null}
                            {this.context.consentListDisabled ?

                                <Button
                                    size="small"
                                    variant="contained"
                                    component={Link} to={baseUrl +"/consentHolidays"}
                                    className={classes.buttonForApproved + ' add-holiday'}>
                                    <List className='white-back-button'></List>за съгласуване
                                    </Button>
                                : null}
                        </div>
                    </Grid>
                    {this.state.rows.length > 0 ?
                        <HolidaysTable list={this.state.rows}></HolidaysTable>
                        : null}
                </Paper>
            </main>
        </React.Fragment>

    )
}

}

MyHolidays.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(withSnackbar(MyHolidays)));